var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovedLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "208 -824 664 688",
    width: 20,
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m715.38-457.38-22.53-22.54 111.92-110.93q-174.08-7.84-244.12 29.35-70.03 37.19-95.73 67.19 37.31-86.61 131.54-114.84t207.31-28.23l-110.92-111.7 22.53-21.54L872-614zM479.23-136Q338.38-257.69 273.19-363.12 208-468.54 208-553.54q0-114.61 79.08-192.54Q366.15-824 479.23-824q39 0 75.62 8.62 36.61 8.61 70.07 29.92l-23.23 24q-31.15-16.92-61.96-23.73t-60.5-6.81Q380-792 310-723.54t-70 170q0 73.39 58.19 166.96Q356.38-293 479.23-177.92q49.69-45.46 95-96.66 45.31-51.19 97.62-121.27l22.77 22.77q-55.47 76-108.66 133.85T479.23-136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovedLocation);
export default __webpack_public_path__ + "static/media/moved_location.1cd50a00c338d7502f611cf2bce03b30.svg";
export { ForwardRef as ReactComponent };